import { c as _c } from "react/compiler-runtime";
import { BodyLong, Modal } from "@navikt/ds-react";
import { useParams } from "next/navigation";
import { useActionState } from "react";
import { knappKlikket } from "@/common/analytics/events-and-properties/knappKlikket-properties";
import { slettUtkastAndRedirectToNyPlanServerAction } from "@/server/actions/slettUtkast";
import { FetchErrorAlert } from "@/ui/FetchErrorAlert";
import { TrackedButton } from "@/ui/TrackedButton";
interface Props {
  ref: React.RefObject<HTMLDialogElement | null>;
}
export function VilDuSletteUtkastForALageNyPlanModal(t0) {
  const $ = _c(21);
  const {
    ref
  } = t0;
  const {
    narmesteLederId
  } = useParams();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      error: null
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [t2, slettUtkastAndRedirectAction, isPendingSlettUtkast] = useActionState(slettUtkastAndRedirectToNyPlanServerAction, t1);
  const {
    error
  } = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      heading: "Slett utkast?"
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <BodyLong>Du har allerede et utkast. Hvis du fortsetter vil utkastet ditt bli slettet. Vil du fortsette?</BodyLong>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== error) {
    t5 = <Modal.Body>{t4}<FetchErrorAlert error={error} className="mt-4" /></Modal.Body>;
    $[3] = error;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== narmesteLederId) {
    t6 = () => slettUtkastAndRedirectAction(narmesteLederId);
    $[5] = narmesteLederId;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isPendingSlettUtkast) {
    t7 = <TrackedButton type="submit" variant="primary" loading={isPendingSlettUtkast} tracking={knappKlikket.aktivPlanSide.sletteUtkastForALageNyModal.bekreft}>Slett utkast og fortsett</TrackedButton>;
    $[7] = isPendingSlettUtkast;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <form action={t6}>{t7}</form>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== ref) {
    t9 = <TrackedButton variant="secondary" onClick={() => {
      ref.current?.close();
    }} tracking={knappKlikket.aktivPlanSide.sletteUtkastForALageNyModal.avbryt}>Avbryt</TrackedButton>;
    $[12] = ref;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8 || $[15] !== t9) {
    t10 = <Modal.Footer>{t8}{t9}</Modal.Footer>;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== ref || $[18] !== t10 || $[19] !== t5) {
    t11 = <Modal ref={ref} header={t3} closeOnBackdropClick={true}>{t5}{t10}</Modal>;
    $[17] = ref;
    $[18] = t10;
    $[19] = t5;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}